const { isSimilar } = require("../helpers/similarityHelper");
const { SIMILARITY_THRESHOLD } = require("../constants");

/**
 * Müşteri önceliğini hesaplar.
 * @param {Object} order - Sipariş detayları.
 * @param {Array} customers - Müşteriler listesi.
 * @returns {number} Müşteri önceliği.
 */
function calculateCustomerPriority(order, customers) {
  if (!order || !customers || !Array.isArray(customers)) {
    return 1;
  }

  const customer = customers.find(
    (c) => isSimilar(c.name, order.customer, SIMILARITY_THRESHOLD.CLOSE_MATCH)
  );
  return customer ? customer.priority : 1;
}

module.exports={
    calculateCustomerPriority
}